module.exports = __webpack_public_path__ + "img/xbj-04.a55e588c.svg";